<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
              <a-form-model-item
                  ref="menu_ids"
                  label="页面类型"
                  prop="menu_ids"
                  :help="formErr.menu_ids"
                  :validateStatus='!formErr.menu_ids||formErr.menu_ids==""?"":"error"'
              >
                <a-cascader v-model="form.menu_ids" :options="menu" :fieldNames="fieldNames" placeholder="">
                </a-cascader>
<!--                <a-select v-model="form.menu_ids"  allowClear>-->
<!--                <a-select-option :value="item.id" v-for="item in menu">-->
<!--                  {{item.name}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
              </a-form-model-item>
                <a-form-model-item
                        ref="word"
                        label="触发词"
                        prop="word"
                        :help="formErr.word"
                        :validateStatus='!formErr.word||formErr.word==""?"":"error"'
                >
                    <a-input type="textarea"
                            v-model="form.word"
                            @change="(e) => { formErr.word=''}"
                            @blur="(e) => {  form.word = e.target.value.trim();formErr.word='' }"
                    />
                </a-form-model-item>
              <a-form-model-item
                  ref="btn_text"
                  label="按钮文本"
                  prop="btn_text"
                  :help="formErr.btn_text"
                  :validateStatus='!formErr.btn_text||formErr.btn_text==""?"":"error"'
              >
                <a-input
                    :maxLength=20
                    v-model="form.btn_text"
                    @change="(e) => { formErr.btn_text=''}"
                    @blur="(e) => {  form.btn_text = e.target.value.trim();formErr.btn_text='' }"
                />
              </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">
                <a-button type="primary" @click="onSubmit" :style="{marginRight: '8px'}">确定</a-button>
                <a-button @click="onClose">取消</a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm, drawerConfig, validator} from "../../../../../../../../utils/utils"
    import API from "../api";

    export default {
        name: "colorForm",
        props: ["visible", "title", "editId"],
        data() {
            return {  fieldNames: {label: 'name', value: 'id', children: 'children'},
                drawerConfig,
                role: [],
              menu:[],
                form: {
                  menu_ids: [],
                  word:'',
                  btn_text:'',
                  id:'',
                  a_ai_assistant_id:this.$route.query.id
                },
                formErr: {
                  menu_ids: "",
                  word:'',
                  btn_text:'',
                  id:'',
                },
                rules: {
                  menu_ids: [{required: true, message: "请选择页面类型 ", trigger: "change"} ],
                  word: [{required: true, message: "请输入触发词", trigger: "blur"} ],
                  btn_text: [{required: true, message: "请输入按钮文本 ", trigger: "blur"} ],

                },
                layout: {
                    labelCol: {span: 4},
                    wrapperCol: {span: 14},
                },
            };
        },
        watch: {
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        this.form = res.data.data
                        this.form.id = a
                        this.form.a_ai_assistant_id=this.$route.query.id
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted() {
          this.getSelect()
        },
        methods: {
          getSelect(){
            API.service.GET_MENU( ).then(res => {
              this.menu = res.data.data

            })

          },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr = {  name: "",
                  menu_ids: "",
                  word:'',
                  btn_text:'',
                  id:'',a_ai_assistant_id:this.$route.query.id}
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                      url( _this.form).then(res => {
                            if (res.data.code == 200) {
                            this.$message.success(res.data.msg);
                            this.onClose()
                            } else {
                              console.log("res",res)
                                res.data.data.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
